import React from 'react';
import { Box, Text, TextInput } from '@mantine/core';
import { BaseFieldProps } from './types';

export function PercentageField<T extends Record<string, unknown>>({
  entityMetadata,
  fieldLabel,
  disabled,
  rightValue,
  form,
  formFieldName,
  variant,
  fieldName,
  onChange,
}: BaseFieldProps<T>) {
  const inputProps = form.getInputProps(formFieldName);
  const percentageWithRightValue = (
    <Box>
      <Text>%</Text>
      {rightValue}
    </Box>
  );

  return (
    <TextInput
      id={formFieldName}
      required={!entityMetadata.isOptional}
      key={form.key(formFieldName)}
      label={fieldLabel}
      labelProps={{ variant: 'light' }}
      type="number"
      step="any"
      rightSection={percentageWithRightValue}
      disabled={disabled}
      {...inputProps}
      variant={variant}
      onChange={value => onChange(value, fieldName)}
    />
  );
}
